import React from 'react';
import { noop } from 'lodash';
import { logLazyLoadError } from './logLazyLoadError';

// TODO: Migrate to SafeLazyComponent and check all components
/**
 * @deprecated This one does not work over modal/popover. Please use SafeLazyComponent based over orca
 * @type {import('react').FC<import('types/components/common').SafeLazyImportProps>}
 */
const SafeLazyImport = ({
    children,
    fallback = null,
    moduleName = '',
    loader = null,
    onLoadError = noop,
    ...props
}) => {
    const Fallback = React.useCallback(() => fallback, [fallback]);

    const lazyComponent = React.useMemo(() => (
        React.lazy(async () => {
            try {
                return await children();
            } catch (error) {
                logLazyLoadError({ moduleName, error, onLoadError });
                return { default: Fallback };
            }
        })
    ), [Fallback, children, moduleName, onLoadError]);

    return (
        <React.Suspense fallback={loader}>
            {React.createElement(lazyComponent, props)}
        </React.Suspense>
    );
};

export default SafeLazyImport;
